/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquareBracketCurlyRight: {
  name: 'square-bracket-curly-right';
  data: string;
} = {
  name: 'square-bracket-curly-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm0 2h14v14H5V5Zm5 2a1 1 0 0 0 0 2h1v1.382A2 2 0 0 0 11.824 12 2 2 0 0 0 11 13.618V15h-1a1 1 0 1 0 0 2h1a2 2 0 0 0 2-2v-1.382l1.447-.724a1 1 0 0 0 0-1.788L13 10.382V9a2 2 0 0 0-2-2h-1Z" fill="currentColor"/></svg>`,
};
